<script>
    import ThumbnailHoverZoom
        from "./thumbnailHoverZoom.vue";

    export default {
        name: "genericElementTile",
        components: {ThumbnailHoverZoom},
        data() {
            return {
                t_new_item: Lang.langGet("New"),
                hover: false
            }
        },
        props: {
            id: String,
            img: Object,
            src: String,
            isWidget: Boolean,
            height: String,
            isVideo: Boolean,
            addMode: Boolean,
            noIcon: Boolean,
            showHashtag: Boolean,
            titleClass: String,
            cursorIcon: {
                type: String,
                default: 'cursor-pointer'
            }
        },
        methods: {
            handleClick() {
                this.$emit('click');
            },
            handleInfoClick() {
                this.$emit('infoClick');
            }
        },
        computed: {
            noImage() {
                return this.src.includes('img/empty');
            },
            hasInfoClick() {
                return (this.$listeners.infoClick);
            },
        }
    }
</script>

<template>
    <div :class="['image-container elevation-4 rounded drag-drop-card', cursorIcon, noImage ? 'no-image' : '']"
         @mouseover="hover = true"
         @mouseleave="hover = false">

        <thumbnail-hover-zoom
            v-if="!addMode"
            :isDnDElement="true"
            @thumbnailPreviewClick="handleClick"
            v-on="hasInfoClick ? { infoClick: handleInfoClick } : {}"
            :entry="img ? img : {}"
            :isThumbnail="true"
            :isWidget="isWidget"
            :showIcon="true"
            :src="src"
            :cursorIcon = "cursorIcon"
        />

        <div class="placeholder-overlay" v-if="addMode" v-bind:style="{ height: height + 'px' }">
            <div class="wrap" @click.self="handleClick">
                <i @click.self="handleClick" class="fa-regular fa-plus fa-3x text-primary text-center"></i>
            </div>
            <div :class="['d-flex align-center image-title-text py-1 px-2 bg-white justify-center']">
                <div class="text-truncate">{{ t_new_item }}</div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    #media-card-0,
    #template-card-card-0,
    #campaign-card-card-0 {
        height: 100%;
        background-color: var(--color-slider-background);

        .placeholder-overlay {
            display: flex;
            flex-direction: column;
            border-radius: 4px !important;

            .wrap {
                height: var(--thumbnail-hover-zoom-height);
                display: flex;
                flex-direction: column;
                justify-content: space-around;
            }

            .image-title-text {
                background-color: #ffffff;
                border-bottom-left-radius: 4px !important;
                border-bottom-right-radius: 4px !important;
            }
        }
    }
    .col-6.two-in-a-row {
        height: 100%;
    }
    .generic-element-tile-title {
        user-select: none;
        border-radius: 0 0 4px 4px;
    }
    .cursor-default {
        cursor: default !important;
    }

    .drag-drop-card {
        height: 100%;
        transition: outline-color 83.334ms ease,
        outline-width 83.334ms ease,
        box-shadow 83.334ms ease;

        &:hover img,
        &:focus img {
            transform: scale(var(--scale-factor-hover)) !important;
        }

        .thumbnail-hoverzoom-container > .image-title-text.past {
            background-color: var(--color-state-tobesynced) !important;
            color: black !important;
        }

        .thumbnail-hoverzoom-container > .image-title-text.future {
            background-color: var(--color-state-synced) !important;
            color: white !important;
        }
    }
</style>
